export type HandoffSession = {
  id: string;
  credentialsId?: string;
  providerName: string;
  sessionId: string;
  transferId?: string;
  isConsumed: boolean;
};

export type ConsumedHandoffSession = HandoffSession & {
  userAccessToken: string;
  url?: string;
};

export enum HandoffCredentialsAction {
  ADD_CREDENTIALS = 'add-credentials',
  REFRESH_CREDENTIALS = 'refresh-credentials',
  AUTHENTICATE_CREDENTIALS = 'authenticate-credentials',
  UPDATE_CREDENTIALS_CONSENT = 'update-credentials-consent',
  BANKID_AUTH = 'bankid-auth',
  NONE = '',
}

export const isConsumedHandoffSession = (
  handoffSession: ConsumedHandoffSession | HandoffSession | undefined
): handoffSession is ConsumedHandoffSession => {
  if (handoffSession && ('url' in handoffSession || 'userAccessToken' in handoffSession)) {
    return true;
  }

  return false;
};
